/**
 * Prefix of the marketing popover's per-visitor view counter cookie. The CMS `displayId`
 * is appended to it.
 */
export const COOKIE_MARKETING_POPOVER_VIEWS_PREFIX = 'next-app-marketingPopover-'
/**
 * Written once the view cap is reached, so the next visit can skip the request
 * altogether.
 */
export const COOKIE_MARKETING_POPOVER_CAPPED = 'next-app-marketingPopoverCapped'
